import React, { useState } from 'react';

const Input = ({
    label,
    type = 'text',
    placeholder,
    value,
    onChange,
    error,
    required = false,
    disabled = false,
    className = '',
    ...props
}) => {
    const [showPassword, setShowPassword] = useState(false);
    const baseClasses = 'w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors duration-200';
    const errorClasses = error ? 'border-red-500 focus:ring-red-500' : 'border-gray-300';
    const disabledClasses = disabled ? 'bg-gray-100 cursor-not-allowed' : 'bg-white';

    const classes = `${baseClasses} ${errorClasses} ${disabledClasses} ${className}`;

    const isPassword = type === 'password';
    const inputType = isPassword && showPassword ? 'text' : type;

    return (
        <div className="mb-4">
            {label && (
                <label className="block text-sm font-medium text-gray-700 mb-2">
                    {label}
                    {required && <span className="text-red-500 ml-1">*</span>}
                </label>
            )}
            <div className="relative">
                <input
                    type={inputType}
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                    disabled={disabled}
                    className={classes + (isPassword ? ' pr-10' : '')}
                    {...props}
                />
                {isPassword && (
                    <button
                        type="button"
                        className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 rounded-md bg-transparent border-none p-0 flex items-center justify-center hover:text-gray-700 transition-colors"
                        style={{ height: 38, width: 38 }}
                        onClick={() => setShowPassword((prev) => !prev)}
                        aria-label={showPassword ? 'Hide password' : 'Show password'}
                    >
                        {showPassword ? (
                            <img src="/hidden.png" alt="Hide password" style={{ width: 22, height: 22 }} />
                        ) : (
                            <img src="/eye.png" alt="Show password" style={{ width: 22, height: 22 }} />
                        )}
                    </button>
                )}
            </div>
            {error && (
                <p className="mt-1 text-sm text-red-600">{error}</p>
            )}
        </div>
    );
};

export default Input; 